const Forest = props => {
    return (
        <svg className={props.className || ""} viewBox="0 -960 960 960" ><path d="M300-100v-160H37.7L194-500h-75.54L360-845.38l120 172 120-172L841.54-500H766l156.3 240H660v160H540v-160H420v160H300Zm343.61-220h168.85L655.54-560H726L600-740l-82.92 118.31L601.54-500H526l117.61 180Zm-496.07 0h424.92L415.54-560H486L360-740 234-560h70.46L147.54-320Zm0 0h156.92H234h252-70.46 156.92-424.92Zm496.07 0H526h75.54-84.46H726h-70.46 156.92-168.85ZM540-260h120-120Zm142.92 0Z"/></svg>
    )
}
export default Forest;